import { useMemo } from 'react'

import { Control, useWatch } from 'react-hook-form'

import { ConfirmDialog } from 'components/common'
import { ReplaceBookingDriverDtoInput, useGetSupplierAllSubDriversQuery } from 'generated/graphql'

interface IReplaceConfirmDialogProps {
  openConfirmModal: boolean
  setOpenConfirmModal: React.Dispatch<React.SetStateAction<boolean>>
  onConfirm: () => void
  allocatedDriverName: string
  control: Control<ReplaceBookingDriverDtoInput, any>
}

const ReplaceConfirmDialog = ({
  openConfirmModal,
  setOpenConfirmModal,
  onConfirm,
  allocatedDriverName,
  control,
}: IReplaceConfirmDialogProps) => {
  const driverId = useWatch({
    control,
    name: 'driverId',
  })

  const { data: supplierSubDriversData } = useGetSupplierAllSubDriversQuery({
    fetchPolicy: 'cache-only',
  })

  const selectedDriverName = useMemo(() => {
    return supplierSubDriversData?.supplierAllSubDrivers.find((d) => d.id === driverId)?.name
  }, [driverId, supplierSubDriversData?.supplierAllSubDrivers])

  return (
    <ConfirmDialog
      closeAfterTransition={false}
      open={openConfirmModal}
      setOpen={setOpenConfirmModal}
      onConfirm={onConfirm}
      title={'Confirm'}
      message={`You chose to replace the allocated driver ${allocatedDriverName} with the selected ${selectedDriverName}`}
      option1='Discard'
      option2='Proceed'
    />
  )
}
export default ReplaceConfirmDialog
